import { useSession } from "next-auth/react";
import GoogleAuthorizationButton from "./GoogleAuthorizationButton";
import { GoogleButton } from "./GoogleButton";
import useGoogleSignIn from "@/hooks/user/register/useGoogleSignIn";
import { cookiePersistStorage } from "@/helper/common.helper";
import { AuthProviderType } from "@/lib/user/types";
import { useTranslations } from "next-intl";
import IFThen from "@/components/common/IFThen";
import { everyTrue, hasTrue } from "@/helper/helper";
import { sendGTMEvent } from "@next/third-parties/google";
import { gtm } from "@/gtm/events";
type GoogleButtonContainerProps = {
  buttonCls?: string;
};
const GoogleButtonContainer: React.FC<GoogleButtonContainerProps> = ({
  buttonCls
}) => {
  const {
    data: sessionData,
    status
  } = useSession();
  const {
    isGoogleLoading,
    onSignIn
  } = useGoogleSignIn(() => sendGTMEvent({
    event: gtm.login.google_login_success
  }));
  const provider = cookiePersistStorage.getItem("social_provider") as AuthProviderType;
  const isGoogleProvider = provider === AuthProviderType.GOOGLE;
  const isAuthenticated = status === "authenticated";
  const isLoading = status === "loading";
  const userEmail = sessionData?.user?.email;
  const showAuthButton = everyTrue(everyTrue(userEmail, isAuthenticated), isGoogleProvider);
  const t = useTranslations("LoginAndSignup");
  return <IFThen condition={showAuthButton} Then={<GoogleAuthorizationButton loading={hasTrue(isGoogleLoading, isLoading)} user={sessionData?.user} onClick={onSignIn} />} Else={<GoogleButton className={buttonCls} onClick={() => {
    sendGTMEvent({
      event: gtm.login.google_login_try
    });
    onSignIn();
  }} text={t("loginWithGoogle")} loading={hasTrue(isGoogleLoading, isLoading)} />} data-sentry-element="IFThen" data-sentry-component="GoogleButtonContainer" data-sentry-source-file="GoogleButtonContainer.tsx" />;
};
export default GoogleButtonContainer;